import { executeRequest, Request } from '@jfs/network'
import { fetchApiRequestBody } from './ApiBody/fetchApiResponseBody'
import { APIEndPoints } from './APIEndpoints'
import { bankConfig } from './config'

const responseParser = (data: any) => {
  return data?.data?.response
}

const fetchIFSC = (tokens: any, userAccessToken: string, dataObj: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.searchIFSC,
    method: 'POST',
    config: bankConfig(tokens, true),
    body: fetchApiRequestBody(dataObj),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken ?? '',
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { fetchIFSC }
